const template = require('./account_metrics.html.slim')

declare var angular

export class AccountMetrics {
  public inception
  public metricChange
  public dateRange
  public loaded: Boolean
}

angular.module('wbComponents').directive('wbAccountMetrics', function() {
  return {
    restrict: 'E',
    templateUrl: template,
    controller: AccountMetrics,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      inception: '=',
      metricChange: '=',
      dateRange: '=',
      loaded: '='
    }
  }
})
